import goalForGoodImage from "@/assets/goal-for-good-event.jpg";
import focoCheck from "@/assets/goal-for-good/foco-check.jpg";
import goalForGoodLogo from "@/assets/goal-for-good/goal-for-good-logo.jpg";
import tournamentAction1 from "@/assets/goal-for-good/tournament-action-1.jpg";
import tournamentAction2 from "@/assets/goal-for-good/tournament-action-2.jpg";
import tournamentAction3 from "@/assets/goal-for-good/tournament-action-3.jpg";
import sponsorPeoplesSavings from "@/assets/goal-for-good/sponsor-peoples-savings.jpg";

export interface ImpactStory {
  id: string;
  title: string;
  date: Date;
  shortDescription: string;
  fullDescription: string;
  amountRaised?: string;
  beneficiary: string;
  organizer?: string;
  imageUrl?: string;
  dialogHeaderImage?: string;
  galleryImages?: string[];
  category: "fundraising" | "community-service" | "collaboration" | "education" | "other";
}

export const impactStories: ImpactStory[] = [
  {
    id: "goal-for-good-2024",
    title: "Goal for Good Charity Tournament",
    date: new Date(2024, 9, 26), // October 26, 2024
    shortDescription: "First annual charity soccer tournament raised over $5,400 for Franklin County Foster Closet",
    fullDescription: `A total of eight soccer squads gathered at the St. Francis Borgia High School sports fields on Saturday, October 26th, 2024, for the first annual Goal for Good Charity Tournament, benefiting the Franklin County Foster Closet.

The event, organized by RCN member Jonathan Pickens, raised over $5,400 for the Foster Closet. Pickens shared that he and several others pooled money donated by Thrivent, a nonprofit financial services organization and Pickens' employer, specifically to be used for a fundraiser or service project.

Organizers also secured sponsorships from several local businesses and a donation of field time and equipment use from Borgia High School.

Pickens explained that he wanted to raise money and awareness for the Foster Closet partly because of his admiration for the efforts of its executive director, RCN member Amber Raney.

"It's just really cool whenever people can see what their talents are and figure out how they can use those to benefit people in the community," Raney said.`,
    amountRaised: "$5,400+",
    beneficiary: "Franklin County Foster Closet",
    organizer: "Jonathan Pickens",
    imageUrl: tournamentAction3,
    dialogHeaderImage: tournamentAction2,
    galleryImages: [
      focoCheck,
      goalForGoodLogo,
      tournamentAction1,
      sponsorPeoplesSavings
    ],
    category: "fundraising"
  }
];

export const impactStats = [
  {
    value: "$5,400+",
    label: "Raised for Local Nonprofits",
    icon: "💰"
  },
  {
    value: "24+",
    label: "Active Network Members",
    icon: "👥"
  },
  {
    value: "150+",
    label: "Referrals Exchanged",
    icon: "🤝"
  },
  {
    value: "2024",
    label: "Founded in Washington, MO",
    icon: "📍"
  }
];
